import { GET, POST } from '@/shared/api/requests';
import type {
  CreateUnitTourResponse,
  UnitTourCompletionResponse,
  UnitTourData,
} from './types';

const BASE = '/punchlists';

/** Public: resolve a unit tour by token (no login required). */
export const getUnitTour = async (token: string): Promise<UnitTourData> => {
  const response = await GET(`${BASE}/unit-tours/${token}/`);
  return response.data as UnitTourData;
};

/** Public: submit completion proof for a punch item from the unit tour. */
export const completeUnitTourItem = async (
  token: string,
  itemId: string,
  companyId: number | null,
  files: File[],
  certifierName?: string,
): Promise<UnitTourCompletionResponse> => {
  const formData = new FormData();
  if (companyId != null) formData.append('company_id', String(companyId));
  if (certifierName) formData.append('certifier_name', certifierName);
  files.forEach((file) => formData.append('photos', file));
  const response = await POST(
    `${BASE}/unit-tours/${token}/items/${itemId}/complete/`,
    formData,
  );
  return response.data as UnitTourCompletionResponse;
};

/** Authenticated: get-or-create the QR tour token for a unit (AreaTag). */
export const createUnitTour = async (
  projectId: number,
  areaTagId: number,
): Promise<CreateUnitTourResponse> => {
  const response = await POST(`${BASE}/unit-tours/`, {
    project_id: projectId,
    area_tag_id: areaTagId,
  });
  return response.data as CreateUnitTourResponse;
};
